import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'progressBarState'
})
export class ProgressBarStatePipe implements PipeTransform {
    transform(value: boolean): string {
        return value ? 'indeterminate' : '';
    }
}
